import { withScalars } from "apollo-link-scalars";
import introspectionResult from "@graphql-generated/client-schema.json";
import { buildClientSchema, IntrospectionQuery } from "graphql";
import { DateScalar } from "@config/apollo/scalars/date-scalar";
import { PermissionScalar } from "@config/apollo/scalars/permissions-scalar";
import { PointScalar } from "@config/apollo/scalars/point-scalar";
import { GeometryScalar } from "@config/apollo/scalars/geometry-scalar";

const schema = buildClientSchema(introspectionResult as unknown as IntrospectionQuery);

export const customScalarsLink = withScalars({
    schema,
    typesMap: {
        DateTime: DateScalar,
        MapStringPermission: PermissionScalar,
        Point: PointScalar(),
        Geometry: GeometryScalar(),
    },
});
